// extracted by mini-css-extract-plugin
module.exports = {"barrier":"PianoBarrier_barrier__K0J8u"};